import config from 'app/config';
import request from 'superagent';
import { getUserToken, getUserId, userLogin } from 'services/authentication';
import store from 'app/store';

function changePassword(username, currentPassword, newPassword) {
  return new Promise((resolve, reject) => {
    const host = config.get('AUTH_HOST');

    store.dispatch(userLogin({ username, password: currentPassword })).then(() => {
      const changePasswordEndpoint = `${host}/v1/users/${getUserId()}`;

      request
        .patch(changePasswordEndpoint)
        .set('Authorization', `Bearer ${getUserToken()}`)
        .send({ password: newPassword })
        .end((err, res) => {
          if (err) {
            return reject(err);
          }
          return resolve(res.body);
        });
    }, reject);
  });
}

export default changePassword;
